import React, { useContext } from 'react';

import { SchoolsApi } from '../apis';
import { api } from '../api';

const SchoolsApiContext = React.createContext(new SchoolsApi(api));

export const SchoolsApiProvider = SchoolsApiContext.Provider;
export const useSchoolsApi = (): SchoolsApi => useContext(SchoolsApiContext);
